import React from 'react';
import {
  Container,
  Banner,
  Content,
  Header,
  Title,
  SubTitle,
  MetaInfo,
  MetaItem,
  Tags,
  Tag,
  Description,
  Section,
  SectionTitle,
  EpisodeList,
  Episode,
  EpisodeImage,
  EpisodeInfo,
  EpisodeTitle,
  EpisodeDuration,
  RelatedVideos,
  VideoCard,
  VideoImage,
  VideoInfo,
  VideoTitle,
  VideoMeta,
  RecommendedFilms,
  FilmCard,
  FilmPoster,
  FilmTitle,
  FilmMeta,
  BackButton,
  CommentSection,
  CommentInput,
  CommentButton,
  CommentList,
  Comment,
  CommentAuthor,
  CommentText,
  ActionButtons,
  PlayButton,
  AddToListButton,
  ShortVideos,
  ShortVideoCard,
  ShortVideoThumbnail,
  ShortVideoInfo,
  ShortVideoTitle,
  ShortVideoDescription,
  PopupOverlay,
  PopupContent,
  PopupClose,
  PopupVideoSection,
  PopupVideoPlayer,
  PopupVideo,
  PopupVideoTitle,
  PopupShortVideosList,
  PopupShortVideoGrid,
  PopupSidebar,
  PopupAdCard,
  PopupAdImage,
  PopupAdInfo,
  PopupAdTitle,
  PopupAdDescription,
  PopupAdLink,
  PopupAdQR,
  MainContent,
  InfoColumn,
  PosterColumn,
  Poster,
} from './styles/film-detail';

export default function FilmDetail({ children, ...restProps }) {
  return <Container {...restProps}>{children}</Container>;
}

FilmDetail.Banner = function FilmDetailBanner({ children, ...restProps }) {
  return <Banner {...restProps}>{children}</Banner>;
};

FilmDetail.Content = function FilmDetailContent({ children, ...restProps }) {
  return <Content {...restProps}>{children}</Content>;
};

FilmDetail.Header = function FilmDetailHeader({ children, ...restProps }) {
  return <Header {...restProps}>{children}</Header>;
};

FilmDetail.Title = function FilmDetailTitle({ children, ...restProps }) {
  return <Title {...restProps}>{children}</Title>;
};

FilmDetail.SubTitle = function FilmDetailSubTitle({ children, ...restProps }) {
  return <SubTitle {...restProps}>{children}</SubTitle>;
};

FilmDetail.MetaInfo = function FilmDetailMetaInfo({ children, ...restProps }) {
  return <MetaInfo {...restProps}>{children}</MetaInfo>;
};

FilmDetail.MetaItem = function FilmDetailMetaItem({ children, ...restProps }) {
  return <MetaItem {...restProps}>{children}</MetaItem>;
};

FilmDetail.Tags = function FilmDetailTags({ children, ...restProps }) {
  return <Tags {...restProps}>{children}</Tags>;
};

FilmDetail.Tag = function FilmDetailTag({ children, ...restProps }) {
  return <Tag {...restProps}>{children}</Tag>;
};

FilmDetail.Description = function FilmDetailDescription({ children, ...restProps }) {
  return <Description {...restProps}>{children}</Description>;
};

FilmDetail.Section = function FilmDetailSection({ children, ...restProps }) {
  return <Section {...restProps}>{children}</Section>;
};

FilmDetail.SectionTitle = function FilmDetailSectionTitle({ children, ...restProps }) {
  return <SectionTitle {...restProps}>{children}</SectionTitle>;
};

FilmDetail.EpisodeList = function FilmDetailEpisodeList({ children, ...restProps }) {
  return <EpisodeList {...restProps}>{children}</EpisodeList>;
};

FilmDetail.Episode = function FilmDetailEpisode({ children, ...restProps }) {
  return <Episode {...restProps}>{children}</Episode>;
};

FilmDetail.EpisodeImage = function FilmDetailEpisodeImage({ ...restProps }) {
  return <EpisodeImage {...restProps} />;
};

FilmDetail.EpisodeInfo = function FilmDetailEpisodeInfo({ children, ...restProps }) {
  return <EpisodeInfo {...restProps}>{children}</EpisodeInfo>;
};

FilmDetail.EpisodeTitle = function FilmDetailEpisodeTitle({ children, ...restProps }) {
  return <EpisodeTitle {...restProps}>{children}</EpisodeTitle>;
};

FilmDetail.EpisodeDuration = function FilmDetailEpisodeDuration({ children, ...restProps }) {
  return <EpisodeDuration {...restProps}>{children}</EpisodeDuration>;
};

FilmDetail.RelatedVideos = function FilmDetailRelatedVideos({ children, ...restProps }) {
  return <RelatedVideos {...restProps}>{children}</RelatedVideos>;
};

FilmDetail.VideoCard = function FilmDetailVideoCard({ children, ...restProps }) {
  return <VideoCard {...restProps}>{children}</VideoCard>;
};

FilmDetail.VideoImage = function FilmDetailVideoImage({ ...restProps }) {
  return <VideoImage {...restProps} />;
};

FilmDetail.VideoInfo = function FilmDetailVideoInfo({ children, ...restProps }) {
  return <VideoInfo {...restProps}>{children}</VideoInfo>;
};

FilmDetail.VideoTitle = function FilmDetailVideoTitle({ children, ...restProps }) {
  return <VideoTitle {...restProps}>{children}</VideoTitle>;
};

FilmDetail.VideoMeta = function FilmDetailVideoMeta({ children, ...restProps }) {
  return <VideoMeta {...restProps}>{children}</VideoMeta>;
};

FilmDetail.RecommendedFilms = function FilmDetailRecommendedFilms({ children, ...restProps }) {
  return <RecommendedFilms {...restProps}>{children}</RecommendedFilms>;
};

FilmDetail.FilmCard = function FilmDetailFilmCard({ children, ...restProps }) {
  return <FilmCard {...restProps}>{children}</FilmCard>;
};

FilmDetail.FilmPoster = function FilmDetailFilmPoster({ ...restProps }) {
  return <FilmPoster {...restProps} />;
};

FilmDetail.FilmTitle = function FilmDetailFilmTitle({ children, ...restProps }) {
  return <FilmTitle {...restProps}>{children}</FilmTitle>;
};

FilmDetail.FilmMeta = function FilmDetailFilmMeta({ children, ...restProps }) {
  return <FilmMeta {...restProps}>{children}</FilmMeta>;
};

FilmDetail.BackButton = function FilmDetailBackButton({ children, ...restProps }) {
  return <BackButton {...restProps}>{children}</BackButton>;
};

FilmDetail.CommentSection = function FilmDetailCommentSection({ children, ...restProps }) {
  return <CommentSection {...restProps}>{children}</CommentSection>;
};

FilmDetail.CommentInput = function FilmDetailCommentInput({ ...restProps }) {
  return <CommentInput {...restProps} />;
};

FilmDetail.CommentButton = function FilmDetailCommentButton({ children, ...restProps }) {
  return <CommentButton {...restProps}>{children}</CommentButton>;
};

FilmDetail.CommentList = function FilmDetailCommentList({ children, ...restProps }) {
  return <CommentList {...restProps}>{children}</CommentList>;
};

FilmDetail.Comment = function FilmDetailComment({ children, ...restProps }) {
  return <Comment {...restProps}>{children}</Comment>;
};

FilmDetail.CommentAuthor = function FilmDetailCommentAuthor({ children, ...restProps }) {
  return <CommentAuthor {...restProps}>{children}</CommentAuthor>;
};

FilmDetail.CommentText = function FilmDetailCommentText({ children, ...restProps }) {
  return <CommentText {...restProps}>{children}</CommentText>;
};

FilmDetail.ActionButtons = function FilmDetailActionButtons({ children, ...restProps }) {
  return <ActionButtons {...restProps}>{children}</ActionButtons>;
};

FilmDetail.PlayButton = function FilmDetailPlayButton({ children, ...restProps }) {
  return <PlayButton {...restProps}>{children}</PlayButton>;
};

FilmDetail.AddToListButton = function FilmDetailAddToListButton({ children, ...restProps }) {
  return <AddToListButton {...restProps}>{children}</AddToListButton>;
};

FilmDetail.ShortVideos = function FilmDetailShortVideos({ children, ...restProps }) {
  return <ShortVideos {...restProps}>{children}</ShortVideos>;
};

FilmDetail.ShortVideoCard = function FilmDetailShortVideoCard({ children, ...restProps }) {
  return <ShortVideoCard {...restProps}>{children}</ShortVideoCard>;
};

FilmDetail.ShortVideoThumbnail = function FilmDetailShortVideoThumbnail({ ...restProps }) {
  return <ShortVideoThumbnail {...restProps} />;
};

FilmDetail.ShortVideoInfo = function FilmDetailShortVideoInfo({ children, ...restProps }) {
  return <ShortVideoInfo {...restProps}>{children}</ShortVideoInfo>;
};

FilmDetail.ShortVideoTitle = function FilmDetailShortVideoTitle({ children, ...restProps }) {
  return <ShortVideoTitle {...restProps}>{children}</ShortVideoTitle>;
};

FilmDetail.ShortVideoDescription = function FilmDetailShortVideoDescription({ children, ...restProps }) {
  return <ShortVideoDescription {...restProps}>{children}</ShortVideoDescription>;
};

FilmDetail.PopupOverlay = function FilmDetailPopupOverlay({ children, ...restProps }) {
  return <PopupOverlay {...restProps}>{children}</PopupOverlay>;
};

FilmDetail.PopupContent = function FilmDetailPopupContent({ children, ...restProps }) {
  return <PopupContent {...restProps}>{children}</PopupContent>;
};

FilmDetail.PopupClose = function FilmDetailPopupClose({ children, ...restProps }) {
  return <PopupClose {...restProps}>{children}</PopupClose>;
};

FilmDetail.PopupVideoSection = function FilmDetailPopupVideoSection({ children, ...restProps }) {
  return <PopupVideoSection {...restProps}>{children}</PopupVideoSection>;
};

FilmDetail.PopupVideoPlayer = function FilmDetailPopupVideoPlayer({ children, ...restProps }) {
  return <PopupVideoPlayer {...restProps}>{children}</PopupVideoPlayer>;
};

FilmDetail.PopupVideo = function FilmDetailPopupVideo({ ...restProps }) {
  return <PopupVideo {...restProps} />;
};

FilmDetail.PopupVideoTitle = function FilmDetailPopupVideoTitle({ children, ...restProps }) {
  return <PopupVideoTitle {...restProps}>{children}</PopupVideoTitle>;
};

FilmDetail.PopupShortVideosList = function FilmDetailPopupShortVideosList({ children, ...restProps }) {
  return <PopupShortVideosList {...restProps}>{children}</PopupShortVideosList>;
};

FilmDetail.PopupShortVideoGrid = function FilmDetailPopupShortVideoGrid({ children, ...restProps }) {
  return <PopupShortVideoGrid {...restProps}>{children}</PopupShortVideoGrid>;
};

FilmDetail.PopupSidebar = function FilmDetailPopupSidebar({ children, ...restProps }) {
  return <PopupSidebar {...restProps}>{children}</PopupSidebar>;
};

FilmDetail.PopupAdCard = function FilmDetailPopupAdCard({ children, ...restProps }) {
  return <PopupAdCard {...restProps}>{children}</PopupAdCard>;
};

FilmDetail.PopupAdImage = function FilmDetailPopupAdImage({ ...restProps }) {
  return <PopupAdImage {...restProps} />;
};

FilmDetail.PopupAdInfo = function FilmDetailPopupAdInfo({ children, ...restProps }) {
  return <PopupAdInfo {...restProps}>{children}</PopupAdInfo>;
};

FilmDetail.PopupAdTitle = function FilmDetailPopupAdTitle({ children, ...restProps }) {
  return <PopupAdTitle {...restProps}>{children}</PopupAdTitle>;
};

FilmDetail.PopupAdDescription = function FilmDetailPopupAdDescription({ children, ...restProps }) {
  return <PopupAdDescription {...restProps}>{children}</PopupAdDescription>;
};

FilmDetail.PopupAdLink = function FilmDetailPopupAdLink({ children, ...restProps }) {
  return <PopupAdLink {...restProps}>{children}</PopupAdLink>;
};

FilmDetail.PopupAdQR = function FilmDetailPopupAdQR({ ...restProps }) {
  return <PopupAdQR {...restProps} />;
};

FilmDetail.MainContent = function FilmDetailMainContent({ children, ...restProps }) {
  return <MainContent {...restProps}>{children}</MainContent>;
};

FilmDetail.InfoColumn = function FilmDetailInfoColumn({ children, ...restProps }) {
  return <InfoColumn {...restProps}>{children}</InfoColumn>;
};

FilmDetail.PosterColumn = function FilmDetailPosterColumn({ children, ...restProps }) {
  return <PosterColumn {...restProps}>{children}</PosterColumn>;
};

FilmDetail.Poster = function FilmDetailPoster({ ...restProps }) {
  return <Poster {...restProps} />;
};
